import { z } from 'zod';
import { entityIdSchema } from '@kop/contracts';
import { riskResponsiblePersonSchema } from './responsible-person.js';
const text = z.string().max(10_000);
export const riskPendingSourceViewSchema = z.object({
    pendingId: entityIdSchema,
    canonicalAssessmentId: entityIdSchema,
    contentHash: z.string().regex(/^[a-f0-9]{64}$/u),
    sourceRound: text, sourceCompanyName: text, sourceProcess: text,
    sourceGroupCount: z.number().int().positive(), updatedAt: text,
    editVersion: z.number().int().nonnegative().default(0),
    title: text.optional(), startsOn: text.optional(), endsOn: text.optional(),
    workCategoryIds: z.array(entityIdSchema).max(500).optional(),
    items: z.array(z.object({
        sourceDocumentId: entityIdSchema, sourcePayloadHash: z.string().regex(/^[a-f0-9]{64}$/u),
        workCategoryId: entityIdSchema.nullable().default(null),
        state: z.enum(['awaiting-input', 'review-required']),
        reconciled: z.boolean().default(false),
        process: text, workStep: text, hazard: text, currentControls: text,
        hazardCategory: text, cause: text, legalBasisText: text,
        likelihood: z.number().int().min(1).max(5).nullable(),
        severity: z.number().int().min(1).max(4).nullable(),
        reassessedLikelihood: z.number().int().min(1).max(5).nullable(),
        reassessedSeverity: z.number().int().min(1).max(4).nullable(),
        originalStoredBefore: z.number().finite().nullable(), originalStoredAfter: z.number().finite().nullable(),
        reductionMeasure: text, responsiblePerson: text, dueDate: text,
        responsibleBinding: riskResponsiblePersonSchema.nullable().optional(),
        reasons: z.array(text),
    }).strict()).min(1).max(80),
}).strict();
export const riskPendingSourcePageSchema = z.object({
    heldCount: z.number().int().min(0).max(30).optional(),
    items: z.array(riskPendingSourceViewSchema).max(30), nextCursor: entityIdSchema.nullable(),
}).strict();
export const riskPendingInputSchema = z.object({
    title: z.string().trim().min(1).max(500),
    startsOn: z.string().regex(/^(?:\d{4}-\d{2}-\d{2})?$/u),
    endsOn: z.string().regex(/^(?:\d{4}-\d{2}-\d{2})?$/u),
    workCategoryIds: z.array(entityIdSchema).max(500),
    items: z.array(riskPendingSourceViewSchema.shape.items.element.pick({
        sourceDocumentId: true, workCategoryId: true, process: true, workStep: true, hazard: true, currentControls: true,
        likelihood: true, severity: true, reassessedLikelihood: true, reassessedSeverity: true,
        reductionMeasure: true, responsiblePerson: true, dueDate: true, responsibleBinding: true,
    }).strict()).min(1).max(80),
}).strict();
export const riskPendingReconciliationResultSchema = z.object({
    assessmentId: entityIdSchema, added: z.number().int().nonnegative(), remaining: z.number().int().nonnegative(), replayed: z.boolean(),
}).strict();
